import { Preference } from '@app/core/model/user-preferences.interface'
import { TableColumnKey } from './table-column-key.enum'

export type TableColumnPreferences = Partial<Record<TableColumnKey, Preference>>

export const isPreferenceActive = (preference: Preference): boolean =>
  preference?.selected && (!preference?.isVisibleInList || preference?.isVisibleInList())
